import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { ChatbotPageRoutingModule } from './chatbot-routing.module';

import { ChatbotPage } from './chatbot.page';
import { NgxMaskModule } from 'ngx-mask';
import { BuscarPropriedadePageModule } from '../buscar-propriedade/buscar-propriedade.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    NgxMaskModule.forRoot(),
    ChatbotPageRoutingModule,
    BuscarPropriedadePageModule
  ],
  declarations: [ChatbotPage]
})
export class ChatbotPageModule {}
